import {
  ToolbarButtonToggle,
  ToolbarButtonToggleProps,
} from "../ToolbarButtonToggle";
import { FilterItemWrapper } from "./FilterItemWrapper";
import { BooleanFilter } from "./internal/types";

import styles from "./Filters.module.scss";

/**
 * Props for the FilterToggleButton component
 *
 * @extends Omit<ToolbarButtonToggleProps, "checked">
 */
export type FilterToggleButtonProps = Omit<
  ToolbarButtonToggleProps,
  "checked"
> & {
  /** Unique identifier for the filter */
  id: string;
  /** Whether the toggle is checked */
  checked: boolean;
  /** The content to display inside the toggle button */
  children: React.ReactNode;
};

/**
 * FilterToggleButton wraps ToolbarButtonToggle in a FilterItemWrapper for consistent overflow behavior with other filter types.
 * Built into FilterGroup for boolean filter rendering.
 *
 * Features:
 * - Renders a toggle button for boolean filters
 * - Integrates with FilterGroup and FilterItemWrapper for overflow handling
 * - Supports accessibility and keyboard navigation
 */
export const FilterToggleButton = ({
  id,
  checked,
  children,
  ...props
}: FilterToggleButtonProps) => {
  // Construct a BooleanFilter object from the props
  const filter: BooleanFilter = {
    id,
    type: "boolean",
    checked,
    label: typeof children === "string" ? children : id,
  };

  return (
    <FilterItemWrapper filter={filter}>
      <ToolbarButtonToggle
        checked={checked}
        isFilter
        {...props}
        className={styles["filter-button-trigger"]}
        data-anv="toolbar-boolean-filter"
      >
        {children}
      </ToolbarButtonToggle>
    </FilterItemWrapper>
  );
};
